import { Button } from "components"
import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"
export const MacroData = () => {
     // language translator
 const { t } = useTranslation("translation")
 return (
  <div className="w-full lg:w-[96%] mx-auto relative h-screen  md:h-screen lg:h-full pt-5">
   <h1 className="Jakarta-font font-semibold text-lg py-3">{t("downloadMacroData")}</h1>
   <Box bg="highlight" className="min-h-[250px] rounded">
    <div className="flex justify-between items-center px-4 pt-4 ">
     <h1 className="text-gray">{t("empty")}</h1>
     <div className="flex">
      <div className="mr-2">
       <Button size={"doublexl"}>Forum Gera</Button>
      </div>
      <Box bg="text" className="rounded">
       <Button size={"doublexl"} color={"gray"}>
        Test Server
       </Button>
      </Box>
     </div>
    </div>
   </Box>
  </div>
 )
}
